import MUITextField from "@mui/material/TextField";
import React from "react";
import Icon from "@mui/material/Icon";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({}));

const TextField = ({ icon, form, field, error, ...rest }) => {
  const classes = useStyles();

  // If Formik form:
  if (form) {
    // We reset error as we want to use the one from the formik:
    error = "";
    if (form && form.errors[field.name] && form.touched[field.name]) {
      console.log("Error", form.errors, form.touched);
      error = form.errors[field.name];
    }
  }

  return (
    <MUITextField
      margin="normal"
      variant="outlined"
      error={error}
      helperText={error}
      {...field}
      {...rest}
    />
  );
};

export default TextField;
